import { useFormikContext } from 'formik'
import React from 'react'

export default function AppSubmit({text, className}) {
    const {handleSubmit} = useFormikContext()
  return (
    <button onClick={handleSubmit} type='submit' className={`${className} bg-slate-600 hover:bg-slate-700 text-white font-semibold py-3 px-4 border border-white hover:border-transparent rounded-xl`}>
        {text}
    </button>
  )
}
